import React from 'react'
import { Stack } from '@mui/material'

export default function ComponentWrapper({ children }) {
    return (
        <Stack sx={{ maxWidth: { xs: '100%', md: '80%'} }}>
            {children}
        </Stack>
    )
}
